export const MARGIN_SPACING_WITHOUT_AVATAR = 5;
